import { useSelector } from 'react-redux';
import { getAdminDisabledReason } from '../authSlice/authSelectors';

export function useAdminDisabledReason() {
  const adminDisabledReason = useSelector(getAdminDisabledReason);
  return adminDisabledReason;
}
